import { render } from "./TheHeader.vue?vue&type=template&id=7b60a818"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script